import { ExtendedConfig } from "../types";

function removeIframe(frameId: string, delay = 300) {
  const iframe = document.getElementById(frameId);
  setTimeout(() => iframe?.remove(), delay);
}

export function cleanupFast(config: ExtendedConfig) {
  const { onLoadingStart, onLoadingEnd, printable, frameId, iframeRemovalDelay } = config;

  // Check for a finished loading hook function
  onLoadingEnd?.();

  // If preloading pdf files, clean blob url
  if (onLoadingStart && typeof printable === "string") {
    window.URL.revokeObjectURL(printable);
  }

  // Remove Iframe
  removeIframe(frameId, iframeRemovalDelay);
}

export function cleanUp(config: ExtendedConfig) {
  const { onLoadingEnd, onLoadingStart, printable } = config;

  // Check for a finished loading hook function
  onLoadingEnd?.();

  // If preloading pdf files, clean blob url
  if (onLoadingStart && typeof printable === "string") {
    window.URL.revokeObjectURL(printable);
  }
}
